export default function as<T>(obj: unknown) {
  return obj as T;
}
